import { render, staticRenderFns } from "./archive-page.vue?vue&type=template&id=49435456&scoped=true"
import script from "./archive-page.vue?vue&type=script&lang=js"
export * from "./archive-page.vue?vue&type=script&lang=js"
import style0 from "./archive-page.vue?vue&type=style&index=0&id=49435456&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49435456",
  null
  
)

export default component.exports